import React, { FC } from 'react';

export const Divider: FC = (): JSX.Element => (
  <>
    <span>&#32;</span>
    <span className="divider-style">&#8226;</span>
    <span>&#32;</span>
  </>
);
